import { createUseStyles } from 'react-jss';
import { DefaultProps } from './Button';
// Styles
const useButtonStyles = createUseStyles((theme) => ({
    base: {
        padding: [12, 20],
        transition: 'all 0.3s ease-out',
        borderRadius: ({ rounded }) => (rounded ? theme.borderRadius : 0),
        width: ({ fullWidth }) => (fullWidth ? '100%' : 'auto'),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            cursor: 'pointer'
        },
        '&:disabled': {
            pointerEvents: 'none'
        }
    },
    solid: {
        border: 'none',
        color: ({ color }) => theme.colors[color || DefaultProps.color].contrastText,
        textDecoration: ({ color }) => theme.colors[color || DefaultProps.color].main === 'transparent'
            ? 'underline'
            : 'none',
        backgroundColor: ({ color }) => theme.colors[color || DefaultProps.color].main,
        '&:hover': {
            backgroundColor: ({ color }) => theme.colors[color || DefaultProps.color].main ===
                'transparent'
                ? 'transparent'
                : theme.colors[color || DefaultProps.color].light,
            boxShadow: ({ color }) => theme.colors[color || DefaultProps.color].main ===
                'transparent'
                ? ''
                : '0px 1px 4px 1px rgba(0, 0, 0, 0.25)'
        },
        '&:active': {
            boxShadow: ({ color }) => theme.colors[color || DefaultProps.color].main ===
                'transparent'
                ? ''
                : 'inset 0px 2px 6px rgba(0, 0, 0, 0.25)!important'
        },
        '&:disabled': {
            backgroundColor: ({ color }) => theme.colors[color || DefaultProps.color].main ===
                'transparent'
                ? ''
                : theme.colors.grey[4],
            color: theme.colors.grey[2]
        }
    },
    outlined: {
        color: ({ color }) => theme.colors[color || DefaultProps.color].main,
        border: '1px solid',
        borderColor: ({ color }) => theme.colors[color || DefaultProps.color].main,
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: ({ color }) => theme.colors[color || DefaultProps.color].light,
            borderColor: ({ color }) => theme.colors[color || DefaultProps.color].light,
            boxShadow: '0px 1px 4px 1px rgba(0, 0, 0, 0.25)',
            color: ({ color }) => theme.colors[color || DefaultProps.color].contrastText
        },
        '&:active': {
            color: ({ color }) => theme.colors[color || DefaultProps.color].main,
            border: '1px solid',
            borderColor: ({ color }) => theme.colors[color || DefaultProps.color].main,
            backgroundColor: 'transparent!important'
        },
        '&:disabled': {
            borderColor: theme.colors.grey[4],
            color: theme.colors.grey[3]
        }
    },
    text: {
        color: ({ color }) => theme.colors[color || DefaultProps.color].main,
        backgroundColor: 'transparent',
        border: 'none',
        '&:hover': {
            backgroundColor: theme.colors.grey[5]
        }
    },
    xl: {
        padding: [16, 24]
    },
    iconLeft: { paddingRight: 6 },
    iconRight: { paddingLeft: 6 }
}));
export default useButtonStyles;
